import * as React from 'react';

// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import {SavedFilters} from 'nutshell-core/saved-filters';
import type {SavedFilter, SavedListType, SavedReportId} from 'nutshell-core/types';
import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';

import {
    SavedFilterModalRow,
    getSavedFilterSubtitle,
} from '../../../base/saved-filter-modal/saved-filter-modal-row';

import {getEntityIcon, getEntityBaseUrl} from '../../../../entities/entities-constants';

import {getSavedListSearch} from '../../helpers';

type Props = {
    savedList: SavedFilter<SavedListType>;
    isSelected: boolean;
    onSelect: (arg1: SavedFilter<SavedListType>) => any;
    onDelete: (arg1: SavedReportId) => any;
    sessionUserId: string | null | undefined;
};

export class SavedListsRow extends React.Component<Props> {
    render() {
        const {savedList} = this.props;

        const entityType = SavedFilters.utils.getEntityTypeFromSavedList(savedList);

        // Gauard against invalid savedList.reportType values
        if (!entityType) return null;

        const reportTitle = `${capitalize(getMultipleEntityType(entityType))} view`;
        const EntityIcon = getEntityIcon(entityType);

        const targetBaseUrl = getEntityBaseUrl(entityType);
        const savedListSearch = getSavedListSearch(
            savedList,
            targetBaseUrl,
            window.location.pathname
        );

        return (
            <SavedFilterModalRow
                savedFilter={savedList}
                subtitle={getSavedFilterSubtitle(savedList, reportTitle, this.props.sessionUserId)}
                location={{pathname: targetBaseUrl, search: savedListSearch}}
                icon={EntityIcon}
                isSelected={this.props.isSelected}
                onSelect={this.props.onSelect}
                onDelete={this.props.onDelete}
                // @ts-expect-error
                sessionUserId={this.props.sessionUserId}
            />
        );
    }
}
